<div class="login-page">
  <div class="login-card app-card">
    <div class="login-brand">
      <span class="material-symbols-outlined brand-icon">storefront</span>
      <h1 class="brand-title">Radwa Khallaf</h1>
      <p class="brand-sub">{{ 'auth.brand_sub' | translate }}</p>
    </div>

    <form [formGroup]="loginForm" class="login-form">
      <div class="form-group">
        <label for="loginEmail">{{ 'lbl.email_address' | translate }}</label>
        <input
          formControlName="email"
          id="loginEmail"
          type="email"
          class="form-control themed-input"
          [placeholder]="'ph.email' | translate"
          autocomplete="email"
        />
      </div>

      <div class="form-group">
        <label for="loginPassword">{{ 'lbl.password' | translate }}</label>
        <input
          formControlName="password"
          id="loginPassword"
          type="password"
          class="form-control themed-input"
          [placeholder]="'ph.password' | translate"
          autocomplete="current-password"
        />
      </div>

      <button (click)="login()" type="button" class="login-btn">
        {{ 'btn.sign_in' | translate }}
      </button>

      <div class="login-footer">
        <a routerLink="/forgot-password" class="forgot-link">{{ 'auth.forgot_pw' | translate }}</a>
      </div>
    </form>
  </div>
</div>
